/**
 * Created by anthony on 6/23/14.
 */
var datePickerDirective = angular.module('datePickerDirective', []);
datePickerDirective.directive("mydatepicker", function(){
    return {
        restrict: "E",
        scope:{
            ngModel: "=",
            dateOptions: "=",
            opened: "="
        },
        link: function($scope, element, attrs) {
            $scope.open = function(event){
                event.preventDefault();
                event.stopPropagation();
                $scope.opened = true;
            };

            $scope.clear = function () {
                $scope.ngModel = null;
            };
        },
        templateUrl: 'ism-angular-lib/directives/datepicker/datepicker.html?v=' + versionNo
    }
})

    .controller('myCtrl', function ($scope, $http) {

        $scope.formData      = {};
        $scope.formData.date = "";
        $scope.opened        = false;
        $scope.versionNo = versionNo;

        //Datepicker
        $scope.dateOptions = {
            'year-format': "'yy'",
            'show-weeks' : false
        };
    });